import { apiClient } from './axios';

import type {
  CreateWhatsAppBusinessAccountDto,
  UpdateWhatsAppBusinessAccountDto,
  WhatsAppAssignInboundNumberDto,
  WhatsAppBusinessAccount,
  WhatsAppNumberSyncResponse,
  WhatsAppPhoneNumber,
  WhatsAppSubscribeWebhooksResponse,
} from '@repo/shared-types';

export const whatsappNumbersApi = {
  list: async (): Promise<WhatsAppPhoneNumber[]> => {
    const response = await apiClient.get<WhatsAppPhoneNumber[]>('/whatsapp/numbers');
    return response.data;
  },

  sync: async (): Promise<WhatsAppNumberSyncResponse> => {
    const response = await apiClient.post<WhatsAppNumberSyncResponse>('/whatsapp/numbers/sync');
    return response.data;
  },

  assignInbound: async (
    numberId: string,
    payload: WhatsAppAssignInboundNumberDto,
  ): Promise<WhatsAppPhoneNumber> => {
    const response = await apiClient.patch<WhatsAppPhoneNumber>(
      `/whatsapp/numbers/${numberId}/assign-inbound`,
      payload,
    );
    return response.data;
  },
};

export const whatsappBusinessAccountsApi = {
  list: async (): Promise<WhatsAppBusinessAccount[]> => {
    const response = await apiClient.get<WhatsAppBusinessAccount[]>('/whatsapp/business-accounts');
    return response.data;
  },

  create: async (payload: CreateWhatsAppBusinessAccountDto): Promise<WhatsAppBusinessAccount> => {
    const response = await apiClient.post<WhatsAppBusinessAccount>(
      '/whatsapp/business-accounts',
      payload,
    );
    return response.data;
  },

  update: async (
    id: string,
    payload: UpdateWhatsAppBusinessAccountDto,
  ): Promise<WhatsAppBusinessAccount> => {
    const response = await apiClient.patch<WhatsAppBusinessAccount>(
      `/whatsapp/business-accounts/${id}`,
      payload,
    );
    return response.data;
  },

  subscribe: async (id: string): Promise<WhatsAppSubscribeWebhooksResponse> => {
    const response = await apiClient.post<WhatsAppSubscribeWebhooksResponse>(
      `/whatsapp/business-accounts/${id}/subscribe`,
    );
    return response.data;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/whatsapp/business-accounts/${id}`);
  },
};
